/* Estado da sessão no navegador (filtros, catálogo carregado e rascunhos das telas). */

import { CFG } from './config';
import { isoDe } from './formato';
import type { Catalogo, ConfigGrafico, RelatorioGhg } from '../tipos/api';
import type { Planilha, Sugestao } from './analisePlanilha';

/** Resultado de uma importação de planilha, para a tela. */
export interface ResultadoTela {
  ok: boolean;
  n?: number;
  lidas?: number;
  arquivo?: string;
  msg?: string;
  linha?: unknown;
  parcial?: boolean;
  inseridas?: number;
}

/** Planilha padrão: o modelo da categoria preenchido. */
export interface EstadoImportacao {
  slug: string | null;
  file: File | null;
  planilha: Planilha | null;
  /** Obra para todas as linhas, quando a planilha não tem a coluna Obra. */
  obra: string;
  resultado: ResultadoTela | null;
}

/** Planilha personalizada: colunas sugeridas pela análise e ajustadas pelo usuário. */
export interface EstadoPersonalizada {
  slug: string | null;
  file: File | null;
  planilha: Planilha | null;
  /** Campo → coluna da planilha; FIXO = mesmo valor para todas as linhas. */
  mapa: Record<string, string>;
  /** Valor para todas as linhas, por campo. */
  fixos: Record<string, string>;
  /** Sugestão da análise para cada campo (confiança e motivo). */
  analise: Record<string, Sugestao>;
  /** Correções de valores não identificados: campo → valor da planilha → id escolhido. */
  depara: Record<string, Record<string, string>>;
  pularInvalidas: boolean;
  resultado: ResultadoTela | null;
}

export interface Estado {
  sec: string;
  page: string;
  /** Muda a cada render; cargas assíncronas de telas antigas são descartadas. */
  tk: number;
  f: { ano: number | string; obra: string; escopo: string };
  cat: Catalogo | null;
  catKey: string | null;
  catPromise: Promise<Catalogo> | null;
  catErro: unknown;
  lc: string | null;
  lcVals: Record<string, string>;
  docModo: 'link' | 'upload';
  /** Obra e tipo escolhidos em Processar documentos (mantidos ao trocar entre link e arquivos). */
  docObra: string;
  docTipo: string;
  filesDoc: File[];
  imp: EstadoImportacao;
  pers: EstadoPersonalizada;
  ghg: RelatorioGhg | null;
  /** Gráfico em construção em "Monte seu gráfico". */
  grafico: ConfigGrafico;
  /** Título sugerido ao salvar (vem de uma sugestão ou de um gráfico salvo). */
  graficoTitulo: string;
}

export const state: Estado = {
  sec: 'painel',
  page: 'visao',
  tk: 0,
  f: { ano: CFG.ano, obra: '', escopo: '' },
  cat: null,
  catKey: null,
  catPromise: null,
  catErro: null,
  lc: null,
  lcVals: { data: isoDe(new Date()) },
  docModo: 'link',
  docObra: '',
  docTipo: '',
  filesDoc: [],
  imp: { slug: null, file: null, planilha: null, obra: '', resultado: null },
  pers: { slug: null, file: null, planilha: null, mapa: {}, fixos: {}, analise: {}, depara: {}, pularInvalidas: false, resultado: null },
  ghg: null,
  grafico: { metrica: 'total', dimensao: 'obra', dimensao2: 'escopo', tipo: 'barras', limite: 12, filtros: {} },
  graficoTitulo: '',
};

/** Catálogo já carregado (as telas que dependem dele só renderizam depois do carregamento). */
export function cat(): Catalogo {
  if (!state.cat) throw new Error('Catálogo da empresa ainda não carregado.');
  return state.cat;
}
